const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/content/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { isContentTab } from "@/components/admin/content/content-tabs";
export const Route = createFileRoute("/dashboard/admin/content/")({
  validateSearch: (search: Record<string, unknown>): {
    tab?: ContentTab;
  } => isContentTab(search.tab) ? {
    tab: search.tab
  } : {},
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});